module.exports = __webpack_public_path__ + "img/dava.1e57948c.svg";